import React, { memo } from "react";
import useEventEditDialog from "./index.hooks";
import { Dialog, DialogContent } from "@material-ui/core";
import { Event } from "models";
import { EventEditForm } from "components/index";

type EventEditDialogProps = {};

const EventEditDialog = ({}: EventEditDialogProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    isMobile,
    editMode,
    isOpen,
    handleDialogClose,
    selectedEvent,
  } = useEventEditDialog();

  return (
    selectedEvent && (
      <>
        <Dialog
          open={isOpen}
          onClose={handleDialogClose}
          maxWidth={"md"}
          fullWidth
          classes={classes.dialogPaper}
          fullScreen={isMobile}
        >
          <DialogContent>
            <EventEditForm
              toEdit={editMode}
              event={selectedEvent}
              dialogCloser={handleDialogClose}
            />
          </DialogContent>
        </Dialog>
      </>
    )
  );
};

export default memo(EventEditDialog);
